import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

// What a link to the booking form carries. `from` is where Save and Cancel
// return to. On a desktop the form is a dialog over the page the member is
// on, which `background` names (see App.tsx); on a phone it is a page of
// its own, as before.
export function useBookingLinkState() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const location = useLocation()
  return useMemo(
    () => ({ from: location.pathname + location.search, ...(isDesktop ? { background: location } : {}) }),
    [location, isDesktop],
  )
}
